import {
  getMachineSubTypes,
  MachineType,
} from '@internal/utils/machine/MachineType'
import { TFilterOption } from '@renderer-ui-library/molecules'
import { useMemo } from 'react'
import { useMachineSubTypeName } from 'utils/machine/useMachineSubTypeName'

export const useMachineSubTypeOptions = (
  machineType: MachineType | undefined
) => {
  const { getMachineSubTypeName } = useMachineSubTypeName()

  const machineSubTypeOptions = useMemo<TFilterOption[]>(() => {
    if (!machineType) {
      return []
    }

    const subTypes = getMachineSubTypes(machineType)
    if (!subTypes) {
      return []
    }

    const machineSubTypes = Object.values(subTypes).map((type) => ({
      label: getMachineSubTypeName(type),
      id: type,
    }))

    return machineSubTypes
  }, [getMachineSubTypeName, machineType])

  return { machineSubTypeOptions }
}
